const mapActivityStatus = (payment, options) => {
    const { status } = payment;
    switch (status) {
        case 'NOT_YET_ACTIONED':
            return options.notActioned ?? options.default;
        case 'PENDING':
            return options.pending ?? options.default;
        case 'COMPLETED':
            return options.completed ?? options.default;
        case 'FAILED':
            return options.failed ?? options.default;
        case 'REJECTED':
            return options.rejected ?? options.default;
        case 'EXPIRED':
            return options.expired ?? options.default;
        case 'INVALIDATED':
            return options.invalidated ?? options.default;
        default:
            return options.default;
    }
};
const mapActivitySide = (payment, options) => {
    const { side } = payment;
    switch (side) {
        case 'PAYEE':
            return options.payee ?? options.default;
        case 'PAYER':
            return options.payer ?? options.default;
        default:
            return options.default;
    }
};
const mapActivityType = (payment, options) => {
    const { type } = payment;
    switch (type) {
        case 'DIRECT_PAYMENT':
            return options.payment ?? options.default;
        case 'PAYMENT_REQUEST':
            return options.request ?? options.default;
        case 'INTERNAL_TRANSFER':
            return options.internalTransfer ?? options.default;
        case 'BENEFICIARY_TRANSFER':
            return options.payment ?? options.default;
        default:
            return options.default;
    }
};
const isActivityRepresentable = (payment) => mapActivitySide(payment, { payee: '', payer: '' }) === '' &&
    mapActivityType(payment, {
        payment: mapActivityStatus(payment, {
            notActioned: '',
            pending: '',
            completed: '',
        }),
        internalTransfer: mapActivityStatus(payment, {
            pending: '',
            completed: '',
        }),
        request: mapActivityStatus(payment, {
            notActioned: '',
            pending: '',
            completed: '',
            failed: '',
            rejected: '',
            expired: '',
            invalidated: '',
        }),
    }) === '';
export { mapActivityStatus, mapActivityType, mapActivitySide, isActivityRepresentable, };
export default {
    mapActivityStatus,
    mapActivityType,
    mapActivitySide,
    isActivityRepresentable,
};
